import React from 'react';
import { useFormState } from 'react-hook-form';
import { TableFilterButtons, TableFilterCard, TableFilterSection } from '@repo/ui/Table';
import { SelectorInputField, TextInputField } from '@repo/ui/Form';
import { DateRangePicker } from '@repo/ui/DateRangePicker';
import { useZodFormContext } from '@repo/hooks/useZodFormContext';

import { SelectInputOptions } from '@repo/types/Types';

import { registerDateRange, registerInput } from '@repo/hooks/useZodForm';

interface OptOutsFilterProps {
  TYPES: SelectInputOptions;
}

const OptOutsFilter = ({ TYPES }: OptOutsFilterProps) => {
  const filter = useZodFormContext();
  useFormState();

  if (!filter) {
    return <></>;
  }

  return (
    <TableFilterCard>
      <TableFilterSection>
        <SelectorInputField label="Type" options={TYPES} {...registerInput(filter, 'type')} />
        <TextInputField label="Remote Number" {...registerInput(filter, 'remote_number')} />
        <TextInputField label="Host Number" {...registerInput(filter, 'host_number')} />
        <TextInputField label="Keyword" {...registerInput(filter, 'keyword')} />
      </TableFilterSection>
      <TableFilterSection>
        <TextInputField label="TCR Brand ID" {...registerInput(filter, 'tcr_brand_id')} />
        <TextInputField label="TCR Campaign ID" {...registerInput(filter, 'tcr_campaign_id')} />
      </TableFilterSection>
      <TableFilterSection>
        <DateRangePicker {...registerDateRange(filter, 'start', 'end')} />
      </TableFilterSection>

      <div className="flex justify-end">
        <TableFilterButtons />
      </div>
    </TableFilterCard>
  );
};

export default OptOutsFilter;
